import React, { useState, useEffect } from 'react';
import HomeSection from '../components/HomeSection';
import ScrollSmoothSection from '../components/ScroolSmoothSection';
import LogoHero from '../components/ui/carousel-logo';
import CategoriesSection from '../components/CategoriesSection';
import ResponsiveGrid from '../components/ResponsiveGrid';
import ResponsiveOppoScroll from '../components/ResponsiveOppoScroll';

import Loader from '../components/ui/Loaders.jsx';

function Home() {

    return (
        <div className="relative bg-cream">
            <HomeSection />
            <LogoHero />
            <ScrollSmoothSection />
            <CategoriesSection />
            <ResponsiveGrid />
            <ResponsiveOppoScroll />
        </div>
    );
}

export default Home;
